'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _logo522x = require('./images/logo52@2x.png');

var _logo522x2 = _interopRequireDefault(_logo522x);

var _dld_qrcode = require('./images/dld_qrcode.png');

var _dld_qrcode2 = _interopRequireDefault(_dld_qrcode);

var _icons = require('./images/icons.png');

var _icons2 = _interopRequireDefault(_icons);

var _Locale = require('./lang/Locale');

var _Locale2 = _interopRequireDefault(_Locale);

require('./App.css');

var _info_12x = require('./images/wwwmore/info_1@2x.png');

var _info_12x2 = _interopRequireDefault(_info_12x);

var _info_22x = require('./images/wwwmore/info_2@2x.png');

var _info_22x2 = _interopRequireDefault(_info_22x);

var _info_32x = require('./images/wwwmore/info_3@2x.png');

var _info_32x2 = _interopRequireDefault(_info_32x);

var _info_42x = require('./images/wwwmore/info_4@2x.png');

var _info_42x2 = _interopRequireDefault(_info_42x);

var _info_52x = require('./images/wwwmore/info_5@2x.png');

var _info_52x2 = _interopRequireDefault(_info_52x);

var _info_62x = require('./images/wwwmore/info_6@2x.png');

var _info_62x2 = _interopRequireDefault(_info_62x);

var _info_72x = require('./images/wwwmore/info_7@2x.png');

var _info_72x2 = _interopRequireDefault(_info_72x);

var _info_82x = require('./images/wwwmore/info_8@2x.png');

var _info_82x2 = _interopRequireDefault(_info_82x);

var _info_92x = require('./images/wwwmore/info_9@2x.png');

var _info_92x2 = _interopRequireDefault(_info_92x);

var _info_102x = require('./images/wwwmore/info_10@2x.png');

var _info_102x2 = _interopRequireDefault(_info_102x);

var _info_112x = require('./images/wwwmore/info_11@2x.png');

var _info_112x2 = _interopRequireDefault(_info_112x);

var _info_122x = require('./images/wwwmore/info_12@2x.png');

var _info_122x2 = _interopRequireDefault(_info_122x);

var _info_132x = require('./images/wwwmore/info_13@2x.png');

var _info_132x2 = _interopRequireDefault(_info_132x);

var _info_142x = require('./images/wwwmore/info_14@2x.png');

var _info_142x2 = _interopRequireDefault(_info_142x);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

require('url-search-params-polyfill');

var WebIndex = function (_React$Component) {
    _inherits(WebIndex, _React$Component);

    function WebIndex() {
        var _ref;

        var _temp, _this2, _ret;

        _classCallCheck(this, WebIndex);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = WebIndex.__proto__ || Object.getPrototypeOf(WebIndex)).call.apply(_ref, [this].concat(args))), _this2), _this2.state = {
            beianText: '京ICP备18016017号-7',
            companyEnName: 'Beijing Xiaowei Cloud Inc.',
            downloadHost: 'https://download.xdiarys.com',
            downloadFileName: '/windows/xdiarys-setup-v3.exe',
            macOSUrl: '',
            iOSUrl: '',
            helpRecent: [],
            showBeianText: false,
            showHelp: false,
            isWindow: true,
            contantUsQQWindows: '',
            contantUsQQMacos: '',
            contantUsEmail: 'service@xiaoweiyunfu.com',
            showDownload: false
        }, _temp), _possibleConstructorReturn(_this2, _ret);
    }

    _createClass(WebIndex, [{
        key: 'componentWillMount',
        value: function componentWillMount() {

            var search = new URLSearchParams(location.search);

            var paramTN = search.get("tn");
            if (null != paramTN && paramTN.length > 0) {
                this.setState({ downloadFileName: '/xdiarys_' + paramTN + '.exe' });
            }

            var src = search.get("src");
            if (src == 'macos') {
                this.setState({ isWindow: false });
            }

            var local = _Locale2["default"].GetInstance();
            document.title = local.getMessagebyId('www_title');

            document.querySelector('meta[name="keywords"]').setAttribute('content', local.getMessagebyId('www_keywords'));
            document.querySelector('meta[name="description"]').setAttribute('content', local.getMessagebyId('www_description'));

            var lang = local.getLang();
            if (lang === 'chs') {

                this.GetRecentHelp();
                this.GetContantUs();

                this.setState({ showBeianText: true, showHelp: true, downloadHost: 'https://download.xdiarys.com' });
            }

            var country = 'us';
            if (lang == 'chs') {
                country = 'cn';
            } else if (lang == 'cht') {
                country = 'tw';
            } else if (lang == 'kor') {
                country = 'kr';
            }

            var macOSUrl = 'https://apps.apple.com/' + country + '/app/CalendarTask/id1570563588';
            var iOSUrl = 'https://apps.apple.com/' + country + '/app/CalendarTask/id1570563588?platform=iphone';
            this.setState({ macOSUrl: macOSUrl, iOSUrl: iOSUrl });

            this.state.opSystem = this.getOperatingSystem();

            this.handleScroll = this.handleScroll.bind(this);

            window.addEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var windows_btn = document.getElementById('windows_btn');
            windows_btn.addEventListener("click", function () {
                window._hmt.push(['_trackEvent', 'xdiarys', 'click', 'windows_btn', 1]);
            });

            var macos_btn = document.getElementById('macos_btn');
            macos_btn.addEventListener("click", function () {
                window._hmt.push(['_trackEvent', 'xdiarys', 'click', 'macos_btn', 1]);
            });

            var ios_btn = document.getElementById('ios_btn');
            ios_btn.addEventListener("click", function () {
                window._hmt.push(['_trackEvent', 'xdiarys', 'click', 'ios_btn', 1]);
            });

            var android_btn = document.getElementById('android_btn');
            android_btn.addEventListener("click", function () {
                window._hmt.push(['_trackEvent', 'xdiarys', 'click', 'android_btn', 1]);
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('scroll', this.handleScroll);
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll(event) {

            var scroll = document.documentElement.scrollTop || document.body.scrollTop;

            if (scroll && this.state.isWindow && this.state.opSystem != 'linux' && this.state.opSystem != 'macos') {
                this.setState({ showDownload: true });
            } else {
                this.setState({ showDownload: false });
            }
        }
    }, {
        key: 'GetRecentHelp',
        value: function GetRecentHelp() {

            var _this = this;

            fetch('/api/help/recent/8', {
                method: "GET",
                credentials: 'include',
                headers: {
                    'Accept': 'application/json, text/plain, */*'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (myJson) {
                var currenthelpRecent = _this.state.helpRecent;

                myJson.posts.forEach(function (element) {
                    currenthelpRecent.push(_react2["default"].createElement(
                        'div',
                        { className: 'helplink', key: element.url },
                        _react2["default"].createElement(
                            'a',
                            { href: element.url, className: 'top1' },
                            element.title
                        )
                    ));
                });

                _this.setState({ helpRecent: currenthelpRecent });
                return myJson;
            })["catch"](function (e) {
                console.log(e);
            });
        }
    }, {
        key: 'GetContantUs',
        value: function GetContantUs() {
            var _this = this;

            fetch('/api/help/contantus', {
                method: "GET",
                credentials: 'include',
                headers: {
                    'Accept': 'application/json, text/plain, */*'
                }
            }).then(function (response) {
                return response.json();
            }).then(function (myJson) {

                _this.setState({ contantUsQQWindows: myJson.vdata.qqwindow });
                _this.setState({ contantUsQQMacos: myJson.vdata.qqmacos });
                _this.setState({ contantUsEmail: myJson.vdata.email });

                return myJson;
            })["catch"](function (e) {
                console.log(e);
            });
        }
    }, {
        key: 'getOperatingSystem',
        value: function getOperatingSystem() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            if (userAgent.indexOf("Windows NT") > -1) {
                return "windows";
            }
            if (userAgent.indexOf("Mac OS X") > -1) {
                return "macos";
            }
            if (userAgent.indexOf("Linux") > -1) {
                return "linux";
            }
            if (/Android/.test(userAgent)) {
                return "android";
            }
            if (/like Mac OS X/.test(userAgent)) {
                return "ios";
            }

            return "unknown";
        }
    }, {
        key: 'breakLine',
        value: function breakLine(text) {
            var br = _react2["default"].createElement('br');
            var regex = /(<br \/>)/g;
            return text.split(regex).map(function (line, index) {
                alert(text);
                return line.match(regex) ? _react2["default"].createElement('br', { key: "key_" + index }) : line;
            });
        }
    }, {
        key: 'downloadLinux',
        value: function downloadLinux() {
            document.getElementById("downloadLinuxDropdown").style.marginLeft = 0;
            document.getElementById("downloadLinuxDropdown").classList.toggle("show");
        }
    }, {
        key: 'downloadLinux2',
        value: function downloadLinux2() {
            document.getElementById("downloadLinuxDropdown").classList.toggle("show");
        }
    }, {
        key: 'downloadLinuxX86',
        value: function downloadLinuxX86() {
            document.getElementById("downloadLinuxDropdown").classList.remove("show");
            location.href = this.state.downloadHost + '/linux/calendartask_linux_x86.deb';
        }
    }, {
        key: 'downloadLinuxArm64',
        value: function downloadLinuxArm64() {
            document.getElementById("downloadLinuxDropdown").classList.remove("show");
            location.href = this.state.downloadHost + '/linux/calendartask_linux_arm64.deb';
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var local = _Locale2["default"].GetInstance();
            var moreFunction = local.getMessagebyId('more_function');
            var titleText = local.getMessagebyId('www_title');
            var updateLog = local.getMessagebyId('update_log');
            var slogan_text1 = local.getMessagebyId('slogan_text1');
            var slogan_text2 = local.getMessagebyId('slogan_text2');
            var slogan_text3 = local.getMessagebyId('slogan_text3');
            var windows_button = local.getMessagebyId('windows_button');
            var mac_button = local.getMessagebyId('mac_button');
            var linux_button = local.getMessagebyId('linux_button');
            var scan_download_phone = local.getMessagebyId('scan_download_phone');

            var linux_op_x86 = local.getMessagebyId('linux_op_x86');
            var linux_op_arm64 = local.getMessagebyId('linux_op_arm64');

            var support = local.getMessagebyId('support');
            var support_text1 = local.getMessagebyId('support_text1');
            var support_text2 = local.getMessagebyId('support_text2');
            var support_text3 = local.getMessagebyId('support_text3');
            var copy_right = local.getMessagebyId('copy_right');
            var about_us = local.getMessagebyId('about_us');
            var help = local.getMessagebyId('help');

            var image_1;
            var image_2;
            var image_3;
            var image_4;
            var image_5;

            var lang = local.getLang();

            var content_title1 = "";
            var content_title2 = "";
            var content_title3 = "";
            var content_title4 = "";
            var content_title5 = "";

            var content_text1 = "";
            var content_text2 = "";
            var content_text3 = "";
            var content_text4 = "";
            var content_text5 = "";

            if (this.state.isWindow && lang === 'chs') {
                content_title1 = local.getMessagebyId('content_title_win1');
                content_title2 = local.getMessagebyId('content_title_win2');
                content_title3 = local.getMessagebyId('content_title_win3');
                content_title4 = local.getMessagebyId('content_title_win4');
                content_title5 = local.getMessagebyId('content_title_win5');
                content_text1 = local.getMessagebyId('content_text_win1');
                content_text2 = local.getMessagebyId('content_text_win2');
                content_text3 = local.getMessagebyId('content_text_win3');
                content_text4 = local.getMessagebyId('content_text_win4');
                content_text5 = local.getMessagebyId('content_text_win5');
            } else {
                content_title1 = local.getMessagebyId('content_title1');
                content_title2 = local.getMessagebyId('content_title2');
                content_title3 = local.getMessagebyId('content_title3');
                content_title4 = local.getMessagebyId('content_title4');
                content_text1 = local.getMessagebyId('content_text1');
                content_text2 = local.getMessagebyId('content_text2');
                content_text3 = local.getMessagebyId('content_text3');
                content_text4 = local.getMessagebyId('content_text4');
            }

            if (this.state.isWindow) {
                if (lang === 'chs') {
                    image_1 = require('./images/www/img_chs_win_1.jpg');
                    image_2 = require('./images/www/img_chs_win_2.jpg');
                    image_3 = require('./images/www/img_chs_win_3.jpg');
                    image_4 = require('./images/www/img_chs_win_4.jpg');
                    image_5 = require('./images/www/img_chs_win_5.jpg');
                } else if (lang === 'cht') {
                    image_1 = require('./images/img_cht_win_1.jpg');
                    image_2 = require('./images/img_cht_win_2.jpg');
                    image_3 = require('./images/img_cht_win_3.jpg');
                    image_4 = require('./images/img_cht_win_4.jpg');
                } else if (lang === 'kor') {
                    image_1 = require('./images/img_kor_win_1.jpg');
                    image_2 = require('./images/img_kor_win_2.jpg');
                    image_3 = require('./images/img_kor_win_3.jpg');
                    image_4 = require('./images/img_kor_win_4.jpg');
                } else if (lang === 'usa') {
                    image_1 = require('./images/img_usa_win_1.jpg');
                    image_2 = require('./images/img_usa_win_2.jpg');
                    image_3 = require('./images/img_usa_win_3.jpg');
                    image_4 = require('./images/img_usa_win_4.jpg');
                }
            } else {
                if (lang === 'chs') {
                    image_1 = require('./images/img_chs_1.jpg');
                    image_2 = require('./images/img_chs_2.jpg');
                    image_3 = require('./images/img_chs_3.jpg');
                    image_4 = require('./images/img_chs_4.jpg');
                } else if (lang === 'cht') {
                    image_1 = require('./images/img_cht_1.jpg');
                    image_2 = require('./images/img_cht_2.jpg');
                    image_3 = require('./images/img_cht_3.jpg');
                    image_4 = require('./images/img_cht_4.jpg');
                } else if (lang === 'kor') {
                    image_1 = require('./images/img_kor_1.jpg');
                    image_2 = require('./images/img_kor_2.jpg');
                    image_3 = require('./images/img_kor_3.jpg');
                    image_4 = require('./images/img_kor_4.jpg');
                } else if (lang === 'usa') {
                    image_1 = require('./images/img_usa_1.jpg');
                    image_2 = require('./images/img_usa_2.jpg');
                    image_3 = require('./images/img_usa_3.jpg');
                    image_4 = require('./images/img_usa_4.jpg');
                }
            }

            return _react2["default"].createElement(
                'div',
                { className: 'web' },
                _react2["default"].createElement(
                    'div',
                    { className: 'header' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement('img', { className: 'logo', src: _logo522x2["default"] }),
                        _react2["default"].createElement(
                            'div',
                            { className: 'left' },
                            titleText
                        ),
                        _react2["default"].createElement('div', { className: 'blank' }),
                        _react2["default"].createElement(
                            'a',
                            { className: 'right', href: 'https://help.xdiarys.com/?page_id=177' },
                            updateLog
                        ),
                        _react2["default"].createElement(
                            'a',
                            { className: 'right ml-20', href: 'https://www.xdiarys.com/baseintro' },
                            moreFunction
                        )
                    )
                ),
                this.state.showDownload && _react2["default"].createElement(
                    'div',
                    { className: 'float-area' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'top-area' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'content' },
                            _react2["default"].createElement('img', { className: 'logo', src: _logo522x2["default"] }),
                            _react2["default"].createElement(
                                'div',
                                { className: 'left' },
                                titleText
                            ),
                            _react2["default"].createElement('div', { className: 'blank' }),
                            _react2["default"].createElement(
                                'a',
                                { id: 'windows_btn', className: 'win-btn', href: this.state.downloadHost + this.state.downloadFileName },
                                _react2["default"].createElement('div', { className: 'image' }),
                                windows_button
                            )
                        )
                    )
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'main' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'top' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'left' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'top-text' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'text' },
                                    titleText
                                )
                            ),
                            this.state.isWindow && lang === 'chs' ? _react2["default"].createElement(
                                'div',
                                { className: 'slogan' },
                                slogan_text1
                            ) : _react2["default"].createElement(
                                'div',
                                { className: 'center-text' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'line-text' },
                                    slogan_text1
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'line-text' },
                                    slogan_text2
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'line-text' },
                                    slogan_text3
                                )
                            ),
                            this.state.isWindow && lang === 'chs' ? _react2["default"].createElement(
                                'div',
                                { className: 'subtitle' },
                                slogan_text2
                            ) : null,
                            this.state.isWindow && lang === 'chs' ? _react2["default"].createElement(
                                'div',
                                { className: 'subslogan' },
                                slogan_text3
                            ) : null,
                            _react2["default"].createElement(
                                'div',
                                { className: 'bottom' },
                                function () {
                                    if (_this3.state.opSystem == 'linux') {
                                        return _react2["default"].createElement(
                                            'div',
                                            null,
                                            _react2["default"].createElement(
                                                'a',
                                                { id: 'linux_btn', className: 'linux-btn', onClick: _this3.downloadLinux.bind(_this3) },
                                                _react2["default"].createElement('div', { className: 'image', background: _icons2["default"] }),
                                                linux_button
                                            ),
                                            _react2["default"].createElement('div', { className: 'blank' }),
                                            _react2["default"].createElement(
                                                'a',
                                                { id: 'windows_btn', className: 'win-btn', href: _this3.state.downloadHost + _this3.state.downloadFileName },
                                                _react2["default"].createElement('div', { className: 'image' }),
                                                windows_button
                                            ),
                                            _react2["default"].createElement('div', { className: 'blank' }),
                                            _react2["default"].createElement(
                                                'a',
                                                { id: 'macos_btn', className: 'mac-btn', href: _this3.state.macOSUrl },
                                                _react2["default"].createElement('div', { className: 'image', background: _icons2["default"] }),
                                                mac_button
                                            )
                                        );
                                    } else if (_this3.state.opSystem == 'macos') {
                                        return _react2["default"].createElement(
                                            'div',
                                            null,
                                            _react2["default"].createElement(
                                                'a',
                                                { id: 'macos_btn', className: 'mac-btn', href: _this3.state.macOSUrl },
                                                _react2["default"].createElement('div', { className: 'image', background: _icons2["default"] }),
                                                mac_button
                                            ),
                                            _react2["default"].createElement('div', { className: 'blank' }),
                                            _react2["default"].createElement(
                                                'a',
                                                { id: 'windows_btn', className: 'win-btn', href: _this3.state.downloadHost + _this3.state.downloadFileName },
                                                _react2["default"].createElement('div', { className: 'image' }),
                                                windows_button
                                            ),
                                            _react2["default"].createElement('div', { className: 'blank' }),
                                            _react2["default"].createElement(
                                                'a',
                                                { id: 'linux_btn', className: 'linux-btn', onClick: _this3.downloadLinux2.bind(_this3) },
                                                _react2["default"].createElement('div', { className: 'image', background: _icons2["default"] }),
                                                linux_button
                                            )
                                        );
                                    } else {
                                        return _react2["default"].createElement(
                                            'div',
                                            null,
                                            _react2["default"].createElement(
                                                'a',
                                                { id: 'windows_btn', className: 'win-btn', href: _this3.state.downloadHost + _this3.state.downloadFileName },
                                                _react2["default"].createElement('div', { className: 'image' }),
                                                windows_button
                                            ),
                                            _react2["default"].createElement('div', { className: 'blank' }),
                                            _react2["default"].createElement(
                                                'a',
                                                { id: 'macos_btn', className: 'mac-btn', href: _this3.state.macOSUrl },
                                                _react2["default"].createElement('div', { className: 'image', background: _icons2["default"] }),
                                                mac_button
                                            ),
                                            _react2["default"].createElement('div', { className: 'blank' }),
                                            _react2["default"].createElement(
                                                'div',
                                                { id: 'linux_btn', className: 'linux-btn', onClick: _this3.downloadLinux2.bind(_this3) },
                                                _react2["default"].createElement('div', { className: 'image', background: _icons2["default"] }),
                                                linux_button
                                            )
                                        );
                                    }
                                }(),
                                _react2["default"].createElement(
                                    'div',
                                    { id: 'downloadLinuxDropdown', className: 'dropdown-content' },
                                    _react2["default"].createElement(
                                        'a',
                                        { className: 'dropdown-content-item', onClick: this.downloadLinuxX86.bind(this) },
                                        linux_op_x86
                                    ),
                                    _react2["default"].createElement(
                                        'a',
                                        { className: 'dropdown-content-item', onClick: this.downloadLinuxArm64.bind(this) },
                                        linux_op_arm64
                                    )
                                )
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'right' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'top-text' },
                                scan_download_phone
                            ),
                            _react2["default"].createElement(
                                'div',
                                { className: 'images' },
                                _react2["default"].createElement('img', { className: 'qrcode', src: _dld_qrcode2["default"], border: '0' }),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'download' },
                                    _react2["default"].createElement('a', { id: 'ios_btn', className: 'ios', href: this.state.iOSUrl }),
                                    _react2["default"].createElement('a', { id: 'android_btn', className: 'android', href: this.state.downloadHost + "/android/dkcalendar-release.apk" })
                                )
                            )
                        )
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'center' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'blockbkgnd1' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'block' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'textblock' },
                                    _react2["default"].createElement('div', { className: 'blockbkg' }),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'title' },
                                        content_title1
                                    ),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'content' },
                                        content_text1
                                    )
                                ),
                                _react2["default"].createElement('img', { className: 'image', src: image_1 })
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'blockbkgnd2' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'block' },
                                _react2["default"].createElement('img', { className: 'image', src: image_2 }),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'textblock' },
                                    _react2["default"].createElement('div', { className: 'blockbkg' }),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'title' },
                                        content_title2
                                    ),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'content' },
                                        content_text2
                                    )
                                )
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'blockbkgnd1' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'block' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'textblock' },
                                    _react2["default"].createElement('div', { className: 'blockbkg' }),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'title' },
                                        content_title3
                                    ),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'content' },
                                        content_text3
                                    )
                                ),
                                _react2["default"].createElement('img', { className: 'image', src: image_3 })
                            )
                        ),
                        _react2["default"].createElement(
                            'div',
                            { className: 'blockbkgnd2' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'block' },
                                _react2["default"].createElement('img', { className: 'image', src: image_4 }),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'textblock' },
                                    _react2["default"].createElement('div', { className: 'blockbkg' }),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'title' },
                                        content_title4
                                    ),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'content' },
                                        content_text4
                                    )
                                )
                            )
                        ),
                        this.state.isWindow && lang === 'chs' ? _react2["default"].createElement(
                            'div',
                            { className: 'blockbkgnd1' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'block' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'textblock' },
                                    _react2["default"].createElement('div', { className: 'blockbkg' }),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'title' },
                                        content_title5
                                    ),
                                    _react2["default"].createElement(
                                        'div',
                                        { className: 'content' },
                                        content_text5
                                    )
                                ),
                                _react2["default"].createElement('img', { className: 'image', src: image_5 })
                            )
                        ) : null,
                        this.state.isWindow && lang === 'chs' ? _react2["default"].createElement(
                            'div',
                            { className: 'blockbkgndinfo' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'block' },
                                _react2["default"].createElement(
                                    'table',
                                    { className: 'infotable' },
                                    _react2["default"].createElement(
                                        'tr',
                                        { className: 'infotr' },
                                        _react2["default"].createElement(
                                            'td',
                                            { className: 'infotd' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'container' },
                                                _react2["default"].createElement('img', { className: 'image', src: _info_12x2["default"] }),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'text' },
                                                    '\u65E5\u5386\u4E0A\u53EF\u663E\u793A\u519C\u5386\u3001\u8282\u6C14\u3001\u8282\u5047\u65E5\u3001\u6CD5\u5B9A\u5047\u65E5'
                                                )
                                            )
                                        ),
                                        _react2["default"].createElement(
                                            'td',
                                            { className: 'infotd' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'container' },
                                                _react2["default"].createElement('img', { className: 'image', src: _info_22x2["default"] }),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'text' },
                                                    '\u641C\u7D22\u529F\u80FD\uFF0C\u5FEB\u901F\u67E5\u627E\u8BB0\u5F55\u8FC7\u91CD\u8981\u7684\u4EFB\u52A1'
                                                )
                                            )
                                        )
                                    ),
                                    _react2["default"].createElement(
                                        'tr',
                                        { className: 'infotr' },
                                        _react2["default"].createElement(
                                            'td',
                                            { className: 'infotd' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'container' },
                                                _react2["default"].createElement('img', { className: 'image', src: _info_32x2["default"] }),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'text' },
                                                    '\u65B0\u589E\u4EFB\u52A1\u53EA\u9700\u8981\u56DE\u8F66\uFF0C\u53CA\u7B80\u8BBE\u8BA1\u624D\u662F\u771F\u6B63\u7684\u6548\u7387'
                                                )
                                            )
                                        ),
                                        _react2["default"].createElement(
                                            'td',
                                            { className: 'infotd' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'container' },
                                                _react2["default"].createElement('img', { className: 'image', src: _info_42x2["default"] }),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'text' },
                                                    '\u6559\u5B66\u5468\u8BBE\u7F6E\u3002\u4E13\u4E3A\u8001\u5E08\u548C\u5B66\u751F\u8BBE\u8BA1'
                                                )
                                            )
                                        )
                                    ),
                                    _react2["default"].createElement(
                                        'tr',
                                        { className: 'infotr' },
                                        _react2["default"].createElement(
                                            'td',
                                            { className: 'infotd' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'container' },
                                                _react2["default"].createElement('img', { className: 'image', src: _info_52x2["default"] }),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'text' },
                                                    '\u6D6E\u52A8\u65E5\u5386\u8BBE\u8BA1\uFF0C\u4E00\u773C\u5C31\u53EF\u4EE5\u67E5\u770B\u4E0A\u3001\u4E0B\u5468\u7684\u4EFB\u52A1'
                                                )
                                            )
                                        ),
                                        _react2["default"].createElement(
                                            'td',
                                            { className: 'infotd' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'container' },
                                                _react2["default"].createElement('img', { className: 'image', src: _info_62x2["default"] }),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'text' },
                                                    '\u4E91\u7AEF\u81EA\u52A8\u5907\u4EFD\u5386\u53F2\u6570\u636E\uFF0C\u8F7B\u677E\u67E5\u770B\u5386\u53F2\u8BB0\u5F55'
                                                )
                                            )
                                        )
                                    ),
                                    _react2["default"].createElement(
                                        'tr',
                                        { className: 'infotr' },
                                        _react2["default"].createElement(
                                            'td',
                                            { className: 'infotd' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'container' },
                                                _react2["default"].createElement('img', { className: 'image', src: _info_72x2["default"] }),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'text' },
                                                    '\u4EFB\u610F\u4E00\u5929\u90FD\u53EF\u4EE5\u8BBE\u7F6E\u60A8\u60F3\u8981\u7684\u80CC\u666F\u989C\u8272'
                                                )
                                            )
                                        ),
                                        _react2["default"].createElement(
                                            'td',
                                            { className: 'infotd' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'container' },
                                                _react2["default"].createElement('img', { className: 'image', src: _info_82x2["default"] }),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'text' },
                                                    '\u5B50\u8D26\u53F7\uFF0C\u53EF\u4EE5\u5C06\u60A8\u7684\u5DE5\u4F5C\u3001\u5B66\u4E60\u7684\u4EFB\u52A1\u5206\u5F00\u8BB0\u5F55'
                                                )
                                            )
                                        )
                                    ),
                                    _react2["default"].createElement(
                                        'tr',
                                        { className: 'infotr' },
                                        _react2["default"].createElement(
                                            'td',
                                            { className: 'infotd' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'container' },
                                                _react2["default"].createElement('img', { className: 'image', src: _info_92x2["default"] }),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'text' },
                                                    '\u81EA\u5B9A\u4E49\u91CD\u590D\u4EFB\u52A1\uFF0C\u53EF\u6309\u5929\u3001\u5468\u3001\u6708\u3001\u5E74\u968F\u5FC3\u8BBE\u7F6E'
                                                )
                                            )
                                        ),
                                        _react2["default"].createElement(
                                            'td',
                                            { className: 'infotd' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'container' },
                                                _react2["default"].createElement('img', { className: 'image', src: _info_102x2["default"] }),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'text' },
                                                    '\u672A\u5B8C\u6210\u4EFB\u52A1\u53EF\u4EE5\u81EA\u52A8\u5EF6\u671F\u5230\u7B2C\u4E8C\u5929'
                                                )
                                            )
                                        )
                                    ),
                                    _react2["default"].createElement(
                                        'tr',
                                        { className: 'infotr' },
                                        _react2["default"].createElement(
                                            'td',
                                            { className: 'infotd' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'container' },
                                                _react2["default"].createElement('img', { className: 'image', src: _info_112x2["default"] }),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'text' },
                                                    '\u4EFB\u52A1\u6807\u8BB0\u5B8C\u6210\u540E\uFF0C\u4F1A\u81EA\u52A8\u79FB\u52A8\u5230\u4EFB\u52A1\u7684\u672B\u5C3E'
                                                )
                                            )
                                        ),
                                        _react2["default"].createElement(
                                            'td',
                                            { className: 'infotd' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'container' },
                                                _react2["default"].createElement('img', { className: 'image', src: _info_122x2["default"] }),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'text' },
                                                    '\u5728\u7EBF\u8BBE\u5907\u67E5\u770B\uFF0C\u5E76\u53EF\u4EE5\u64CD\u4F5C\u8BBE\u5907\u4E0B\u7EBF'
                                                )
                                            )
                                        )
                                    ),
                                    _react2["default"].createElement(
                                        'tr',
                                        { className: 'infotr' },
                                        _react2["default"].createElement(
                                            'td',
                                            { className: 'infotd' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'container' },
                                                _react2["default"].createElement('img', { className: 'image', src: _info_132x2["default"] }),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'text' },
                                                    '\u5BFC\u51FAExcel\uFF08PC\u7535\u8111\u7AEF\uFF09\uFF0C\u53EF\u4EE5\u6574\u7406\u4E00\u5E74\u7684\u8BA1\u5212'
                                                )
                                            )
                                        ),
                                        _react2["default"].createElement(
                                            'td',
                                            { className: 'infotd' },
                                            _react2["default"].createElement(
                                                'div',
                                                { className: 'container' },
                                                _react2["default"].createElement('img', { className: 'image', src: _info_142x2["default"] }),
                                                _react2["default"].createElement(
                                                    'div',
                                                    { className: 'text' },
                                                    '\u5C0F\u56E2\u961F\u7248\u672C\uFF0C\u53EF\u591A\u4EBA\u56E2\u961F\u5171\u4EAB\u60A8\u7684\u65E5\u5386\u65E5\u7A0B'
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        ) : null
                    )
                ),
                _react2["default"].createElement(
                    'div',
                    { className: 'footer' },
                    _react2["default"].createElement(
                        'div',
                        { className: 'content' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'center' },
                            _react2["default"].createElement(
                                'div',
                                { className: 'left' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top' },
                                    support
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top1' },
                                    support_text1,
                                    this.state.contantUsEmail
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top1' },
                                    support_text2,
                                    this.state.contantUsQQWindows,
                                    support_text3,
                                    this.state.contantUsQQMacos
                                ),
                                _react2["default"].createElement('br', null),
                                _react2["default"].createElement(
                                    'a',
                                    { href: '/aboutus', className: 'top1' },
                                    about_us
                                )
                            ),
                            this.state.showHelp ? _react2["default"].createElement(
                                'div',
                                { className: 'left' },
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top' },
                                    help
                                ),
                                _react2["default"].createElement(
                                    'div',
                                    { className: 'top1' },
                                    this.state.helpRecent
                                )
                            ) : null
                        )
                    ),
                    _react2["default"].createElement(
                        'div',
                        { className: 'copyright' },
                        _react2["default"].createElement(
                            'div',
                            { className: 'bottom' },
                            copy_right,
                            ' \xA0',
                            this.state.companyEnName,
                            '  ',
                            _react2["default"].createElement(
                                'a',
                                { className: 'link', href: 'privacypolicy' },
                                'Privacy Policy'
                            ),
                            ' / ',
                            _react2["default"].createElement(
                                'a',
                                { className: 'link', href: 'eula' },
                                'EULA'
                            ),
                            this.state.showBeianText ? _react2["default"].createElement(
                                'div',
                                { className: 'beian' },
                                '\xA0\xA0\xA0|\xA0\xA0\xA0 ',
                                _react2["default"].createElement(
                                    'a',
                                    { className: 'link', href: 'http://beian.miit.gov.cn/' },
                                    ' ',
                                    this.state.beianText
                                )
                            ) : null
                        )
                    )
                )
            );
        }
    }]);

    return WebIndex;
}(_react2["default"].Component);

exports["default"] = WebIndex;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./WebIndex.js
// module id = 294
// module chunks = 0